import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCoreFacade } from "../../../core/facades/Core.facade";
import { CoreConstants } from "../../../core/models/constants/core.constants";
import PrwImageUpload from "../../../ui/widgets/form/PrwImageUpload";

const ProfileName = (props: any) => {
  const { data } = props;
  const coreFacade = useCoreFacade();
  const { t } = useTranslation();
  const [avatar, setAvatar] = useState(null);

  const handleOnAvatarChange = (image: any) => {
    console.log("profile image ---");
    console.log(image);
    setAvatar(image);
  };

  const getStatus = (statusKey: string) => {
    if (statusKey) {
      switch (statusKey) {
        case CoreConstants.Status.active.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-green-500 border border-green-500 rounded-md ">
              {t(CoreConstants.Status.active.labelKey)}
            </div>
          );
        case CoreConstants.Status.inactive.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-red-500 border border-red-500 rounded-md ">
              {t(CoreConstants.Status.inactive.labelKey)}
            </div>
          );
        case CoreConstants.Status.pending.key:
          return (
            <div className="inline-block px-2 py-0.5 text-xs font-semibold text-yellow-500 align-middle border border-yellow-500 rounded-md ">
              {t(CoreConstants.Status.pending.labelKey)}
            </div>
          );
      }
    }
  };

  return (
    <div className="flex items-center">
      <div className="mr-6">
        <PrwImageUpload
          onChange={(data: any) => handleOnAvatarChange(data)}
          value={avatar}
          height="24"
          width="24"
        ></PrwImageUpload>
      </div>
      <div>
        <div className="flex items-center">
          <span className="text-xl font-semibold text-gray-700">
            {data &&
              coreFacade.getFullName(data.user.firstName, data.user.lastName)}
          </span>
          <span className="ml-2">{getStatus(data.status)}</span>
        </div>
        <div className="text-sm"><span className="font-semibold text-gray-700">{t("profileSummary.label.lastActivity")}</span><span className="mx-1">-</span><span>{data.lastActivity}</span></div>
      </div>
    </div>
  );
};

export default ProfileName;
